import { call, take, put } from 'redux-saga/effects';
import { SSO_SESSION_ACTIVE } from 'actions/auth';
import { getUserAbbaFlags } from 'api/featureFlags';
import * as actions from 'actions/featureFlags';

export function* fetchUserAbbaFlags() {
  const { accessToken } = yield take(SSO_SESSION_ACTIVE);

  try {
    const flags = yield call(getUserAbbaFlags, accessToken);
    yield put(actions.fetchUserFlagsSuccess(flags));
  } catch (e) {
    yield put(actions.fetchUserFlagsFailed(e));
  }
}



// WEBPACK FOOTER //
// ./src/middleware/sagas/featureFlags.js